// strings/chat.ts (M0-T06, §7.1) — chat UI and the 12 quick phrases
import type { StringBank } from '../schema/strings';

export default {
  title: 'Chat', placeholder: 'Say something…', send: 'Send', quick: 'Quick', log: 'Recent', empty: 'No messages yet.',
  emotes: 'Emotes', tooLong: 'Keep it under {max} characters.',
  phrase1: 'Hi!', phrase2: 'Good morning!', phrase3: 'Good night!', phrase4: 'Come over!', phrase5: 'Follow me!', phrase6: 'Thanks!',
  phrase7: 'Nice catch!', phrase8: 'Be right back', phrase9: 'See you later!', phrase10: 'Love your house!', phrase11: 'Where are you?',
  phrase12: 'Wait for me!',
} as const satisfies StringBank;
